import React from 'react';
import styles from './mobile-icon.module.css';

const MobileIcon = ({ link }) => {

    return (
        <button 
          className={styles.linkItem} 
          style={{ '--link-color': link.color }}
        >
          {/* The Square Icon Container */}
          <div className={styles.iconBox}>
            <div className={styles.innerGlow} />
            <div className={styles.iconContent}>
              {React.cloneElement(link.icon, { 
                size: 32, 
                strokeWidth: 2.5,
                className: styles.svgIcon 
              })}
            </div>
          </div>

          {/* Label below the square */}
          <span className={styles.label}>{link.label}</span>
        </button>
    );
};

export default MobileIcon;